import React, { useEffect, useMemo, useState } from 'react';
import { CardBrand } from '../PayClasses';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { Button, Header, Icon, Image, Placeholder } from 'react-frontier';
import { addCommas, getCardBrandName, isJWT } from '../PublicUtil';
import { useTranslation } from 'react-i18next';
import API, { CDN_URL } from '../PublicAPI';
import classNames from 'classnames';

interface RequestResponse{
	payment_id: number,
	client_id: number,
	paid: boolean,
	cancelled: boolean,
	total: number,
	cancel_reason: number,
	reference: string,
	auth_code: string,
	pay_token: string,
	card: {
		card_last4: number,
		card_brand: CardBrand,
	},
}

var PaymentInfo = (props: { label: string, value: string, className?: string })=>{
	var { t } = useTranslation();
	return <div className={classNames("data", props.className)}>
		<div className="label">{t(props.label)}</div>
		<div className="value">{props.value}</div>
	</div>
}

var RequestResponse = ()=>{
	var { t } = useTranslation();
	var { hash } = useParams<{ hash: string }>();
	var [searchParams] = useSearchParams();
	var [loadError, setLoadError] = useState<string>(null);
	var [response, setResponse] = useState<RequestResponse>(null)

	var hash_valid = useMemo(()=>{
		return isJWT(hash);
	}, [hash]);

	useEffect(()=>{
		API.getRequestPayment(hash).then(res=>{
			if(res.error) return setLoadError(res.message);
			setResponse(res.data);
		}).catch(err=>{
			setLoadError(t('common.unexpected_error', { code: 'PYRQRS-1' }));
		});
	}, []);

	var client_id = useMemo(()=>{
		if(!response){
			var clpr = searchParams.get('c');
			if(!clpr) return null;
			var numclpr = parseInt(clpr);
			if(Number.isNaN(numclpr)) return null;
			return numclpr;
		}else{
			return response.client_id;
		}
	}, [response]);
	
	return <div className="pf pay-request-screen">
		<div className="client">
			{client_id ? (
				<Image src={`${CDN_URL}/clients/${client_id}.webp`} fallbackComponent={(
					<div className='placeholder' />
				)} />
			) : (
				<div className='placeholder' />
			)}
		</div>
		<div className="contents">
			<div className="payment">
				<div className={classNames('icon', {
					placeholder: !response,
					green: response?.paid,
					red: response?.cancelled,
				})}>
					{response ? (
						<Icon name={response.paid ? 'check' : 'remove'} />
					) : null}
				</div>
				{response ? (
					<div className="text">
						{t(`request.payment_${response.paid ? 'paid' : 'cancelled'}`)}
					</div>
				) : (
					<Placeholder className='text' height={25} style={{ marginBottom: 5 }} />
				)}
			</div>
			<div className={classNames("form response", { loading: (!response || !response.paid) })}>
				{response ? (
					response.paid ? <>
						<PaymentInfo label={'request.identifier'} value={response.payment_id.toString()} />
						<PaymentInfo label={'request.amount_paid'} value={`$${addCommas(response.total)}`} />
						<PaymentInfo label={'request.payment_method'} value={t('request.credit_card')} />
						<PaymentInfo label={'request.credit_card'} value={`${(getCardBrandName(response.card?.card_brand) || '')} **${response.card?.card_last4}`} />
						<PaymentInfo label={'request.reference'} value={response.reference} />
						<PaymentInfo label={'request.reference'} value={response.auth_code} />
					</> : <>
						<Header text={t(`cancel_reason.reason_${response.cancel_reason || 1}`, { defaultValue: t('cancel_reason.generic') })} subtext={t('charge.not_charged')} actions={(
							response.pay_token ? (
								<Button text='Reintentar' as={Link} color='black' to={`/request/${response.pay_token}`} />
							) : null
						)} />
						<PaymentInfo className='gray' label={'request.identifier_try'} value={response.payment_id.toString()} />
					</>
				) : (
					!hash_valid ? (
						<Header text={'Error'} subtext={t('request.invalid_link')} />
					) : loadError ? (
						<Header text={'Error'} subtext={loadError} />
					) : <>
						<div className="fr loading big inline"></div>
						<Header text={'Cargando'} className='loading' />
					</>
				)}
			</div>
		</div>
	</div>
}

export default RequestResponse;